export interface IInsuranceCarrierInfo {
    centerInsuranceCarrierId: number,
    carrierName: string,
    centerId: number,
    insuranceCarrierId: number,
    hasGlobalRate: boolean
}